<template>
  <div class="message-box dialog-mask" @click="focusOut">
    <div class="dialog-content">
      <header>{{ title }}</header>
      <div class="dialog-body">
        <div class="helper-dialog-body" v-html="content"></div>
      </div>
      <footer>
        <div class="button-area">
          <button class="button" @click="$close(true)">閉じる</button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    title: String,
    content: String,
  },
  methods: {
    cancel() {
      this.$close(true);
    },
    focusOut(e) {
      if (e.target.classList.contains("dialog-mask")) {
        this.$close(true);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

header {
  font-weight: var(--font-weight-bold);
  font-size: x-large;
  margin: 15px auto;
}

.button-area {
  margin: 10px auto;
  float: right;
}

.fade-enter-active {
  transition: opacity 0.3s;
}

.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.dialog-body {
  font-size: larger;
}

.dialog-mask {
  position: fixed;
  top: -100px;
  right: 0;
  bottom: 0;
  left: 0;
  display: -ms-flexbox;
  display: flex;
  z-index: 9000;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: var(--color-overlay);
}

.dialog-content {
  margin: 0 10px;
  padding: 10px 15px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  background-color: var(--color-background-normal);
  box-shadow: var(--shadow-lg);
  color: var(--color-text-normal);
}

.helper-dialog-body {
  white-space: pre-line;
}
</style>
<style lang="scss">
.helper-dialog-body h3 {
  box-sizing: border-box;
  font-size: 18px;
  margin: 15px 0 0;
  border-bottom: 2px solid #5d627b;
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.05em;
  border-radius: var(--radius-sm) var(--radius-sm) 0 0;
  color: var(--color-text-normal);
}

.helper-dialog-body h4 {
  box-sizing: border-box;
  font-size: var(--font-size-md);
  margin: 15px 0 0;
  padding: 5px 7px;
  width: 100%;
  background-color: var(--color-surface-subtle);
  border-left: 5px solid #5d627b;
  font-weight: var(--font-weight-bold);
  color: var(--color-text-normal);
}
</style>
